export const UserData = [
  {
    id: 1,
    year: 2016,
    weeks: 80000,
    userLost: 823,
  },
  {
    id: 2,
    year: 2017,
    weeks: 45677,
    userLost: 345,
  },
  {
    id: 3,
    year: 2018,
    weeks: 78888,
    userLost: 555,
  },
  {
    id: 4,
    year: 2019,
    weeks: 89999,
    userLost: 4555,
  },
  {
    id: 5,
    year: 2020,
    weeks: 4300,
    userLost: 234,
  },
  {
    id: 6,
    year: 2021,
    weeks: 67800,
    userLost: 437,
  },
  {
    id: 7,
    year: 2022,
    weeks: 64800,
    userLost: 57,
  },
  {
    id: 8,
    year: 2023,
    weeks: 62800,
    userLost: 57,
  }
];
